import { ActionType } from 'src/graphql/entities/behavior/behavior-config/behavior-config.types';
import {
  CustomRuleGroupType,
  ManageConversationLabelsActionRule,
  RulesFormActionRule,
  SignalActionRule,
} from 'src/graphql/entities/behavior/behavior.types';
import { ConversationAssigneeGroupOption } from 'src/graphql/entities/conversation-assignee-group';

export enum MacrosFormFields {
  Name = 'name',
  Description = 'description',
  Visibility = 'public',
  AvailableFor = 'conversationAssigneeGroups',
  MessagePrivacy = 'messagePrivacy',
  Template = 'template',
  Actions = 'actions',
  RecordFolderId = 'recordFolderId',
}

export enum MacroVisibility {
  Everyone = 'public',
  OnlyMe = 'private',
  SpecificGroups = 'groups',
}

export enum MacroMessagePrivacy {
  Private = 'private',
  Public = 'public',
}

export type MacroActionRule = Extract<
  RulesFormActionRule,
  CustomRuleGroupType | ManageConversationLabelsActionRule | SignalActionRule
>;
export type MacroActionType = Extract<
  ActionType,
  'data' | 'manageConversationLabels' | 'signal'
>;

type MacrosFormAction =
  | {
      id: string;
      actionType: ActionType.Data;
      actions: CustomRuleGroupType;
    }
  | {
      id: string;
      actionType: ActionType.ManageConversationLabels;
      actions: ManageConversationLabelsActionRule;
    }
  | {
      id: string;
      actionType: ActionType.Signal;
      actions: SignalActionRule;
    };

export type MacrosFormActions = MacrosFormAction[];

export interface MacrosFormModel {
  [MacrosFormFields.Name]: string;
  [MacrosFormFields.Description]?: string;
  [MacrosFormFields.Template]: string;
  [MacrosFormFields.Actions]: MacrosFormActions;
  [MacrosFormFields.MessagePrivacy]: MacroMessagePrivacy;
  [MacrosFormFields.Visibility]: MacroVisibility;
  [MacrosFormFields.AvailableFor]: ConversationAssigneeGroupOption[];
  [MacrosFormFields.RecordFolderId]?: MacroFolderOption | null;
}

export interface MacroFolderOption {
  id: string;
  label: string;
  value: string;
  partnerId: number;
}
